import * as redux from 'redux';
import { COMPANY_SET } from './actions';

export interface ICompanyState {
    storageLimit: number;
    storageUsed: number;
    percentageUsed: number;
}

function company(state: ICompanyState = { storageLimit: 0, storageUsed: 0, percentageUsed: 0 }, action: any = {}): ICompanyState {
    switch (action.type) {
        case COMPANY_SET:
            return {
                storageLimit: action.storageLimit,
                storageUsed: action.storageUsed,
                percentageUsed: action.percentageUsed,
            };
        default:
            return state;
    }
}

export const rootReducer: redux.Reducer<ICompanyState> = company;
